"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.storageLimitControl = void 0;
const storageLimit = 5242878;
const storageLimitControl = (valueToAdd) => __awaiter(void 0, void 0, void 0, function* () {
    const storage = window === null || window === void 0 ? void 0 : window.localStorage;
    let concatenatedString = valueToAdd;
    if (storage) {
        yield Promise.all(Object.values(storage).map((val) => {
            concatenatedString += val;
        }));
    }
    return concatenatedString.length < storageLimit;
});
exports.storageLimitControl = storageLimitControl;
